export default __webpack_public_path__ + "static/media/2_crew.dfb262c2.jpg";